var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 0.125H0.75C0.567664 0.125 0.392795 0.197433 0.263864 0.326364C0.134933 0.455295 0.0625 0.630164 0.0625 0.8125V12.5C0.0625 12.8647 0.207366 13.2144 0.465228 13.4723C0.723091 13.7301 1.07283 13.875 1.4375 13.875H16.5625C16.9272 13.875 17.2769 13.7301 17.5348 13.4723C17.7926 13.2144 17.9375 12.8647 17.9375 12.5V0.8125C17.9375 0.630164 17.8651 0.455295 17.7361 0.326364C17.6072 0.197433 17.4323 0.125 17.25 0.125ZM15.4823 1.5L9 7.44258L2.51773 1.5H15.4823ZM16.5625 12.5H1.4375V2.3757L8.53508 8.88203C8.66191 8.99846 8.82782 9.06307 9 9.06307C9.17218 9.06307 9.33809 8.99846 9.46492 8.88203L16.5625 2.3757V12.5Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBox);
export default __webpack_public_path__ + "static/media/mailBox.0f2d3d2e410251d9bfd0c98b2de8f3ce.svg";
export { ForwardRef as ReactComponent };